<template>
  <div class="page-header header-filter" style="background-image: url('img/bg32.jpg')">
    <!-- <div class="page-header-image"
             style="background-image: url('img/login.jpg')">
    </div>-->
    <div class="content">
      <div class="container">
        <div class="col-md-5 ml-auto mr-auto">
          <card type="login" plain>
            <div slot="header" class="mr-auto">
              <!-- <img v-lazy="'img/now-logo.png'" alt=""> -->
              <h1 class="title">{{ constants.appTitle }}</h1>
            </div>

            <fg-input
              type="password"
              v-model="form.password"
              autocomplete="off"
              class="no-border input-lg"
              addon-left-icon="now-ui-icons ui-1_lock-circle-open"
              placeholder="Nueva contraseña"
            ></fg-input>

            <fg-input
              type="password"
              v-model="form.confirmPassword"
              autocomplete="off"
              class="no-border input-lg"
              addon-left-icon="now-ui-icons ui-1_lock-circle-open"
              placeholder="Confirmar contraseña"
            ></fg-input>

            <template slot="raw-content">
              <div class="card-footer text-center">
                <a
                  @click="handleOnClick()"
                  class="btn btn-primary btn-round btn-lg btn-block"
                >Cambiar contraseña ></a>
              </div>
              <div class="pull-left"></div>
              <!-- <div class="pull-right">
                <h6>
                  <a href="#/resetrecuperar" class="link footer-link">Recuperar Contraseña</a>
                </h6>
              </div>-->
            </template>
          </card>
        </div>
      </div>
    </div>
    <!-- <main-footer></main-footer> -->
  </div>
</template>
<script>
import { Card, Button, FormGroupInput } from "@/components";
import { Select, Option } from "element-ui";
import * as miscService from "../../services/MiscService";
import * as authService from "../../services/AuthService";

export default {
  name: "login-page",
  bodyClass: "login-page",
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      form: {
        password: "",
        passwordConfirm: ""
      }
    };
  },
  methods: {
    handleOnClick: function() {
      var userId = this.$route.query.userId;
      var code = this.$route.query.code;

      authService.changePassword(
        this.$osapm(),
        code,
        userId,
        this.form.password,
        this.form.confirmPassword,
        success => this.$noty.success(success),
        error => this.$noty.error(error)
      );
    }
  }
};
</script>